import { makeStyles } from '@material-ui/core';
import { masLaFont } from 'assets';

export const useHomePageStyles = makeStyles((theme) => {
  return {
    root: {
      height: '100vh',
      width: '100vw',
    },
    intro: {
      flex: 1,
      background: `url(${masLaFont}) center/cover`,
      color: theme.palette.common.white,
      padding: theme.spacing(1),
    },
    leadFormContainer: {
      flex: 1,
      padding: theme.spacing(1),
    },
  };
});